import { render, staticRenderFns } from "./screenTrivia.vue?vue&type=template&id=65b8cd37&"
import script from "./screenTrivia.vue?vue&type=script&lang=js&"
export * from "./screenTrivia.vue?vue&type=script&lang=js&"
import style0 from "./screenTrivia.vue?vue&type=style&index=0&id=65b8cd37&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports